import _ from 'lodash';

export function focusInputStart(el) {
  el.focus();
  el.selectionStart = 0;
  el.selectionEnd = 0;
  el.scrollTop = 0;
}

export function convertArrayToOptions(items) {
  return _.map(items, item => ({ value: item, label: item }));
}



// WEBPACK FOOTER //
// ./app/utils/input-utils.js